import React from 'react';
import ReactDOM from 'react-dom/client';
import './style/index.css'
import './style/header.css'
import './style/main.css'
import './style/animtaion.css'
import './style/adap.css'
import './style/footer.css'
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);